var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasMounted)?_c('div',[_c('h6',{staticClass:"mb-2"},[_vm._v("New suppliers that will be added")]),_c('webix-ui',{attrs:{"config":_vm.ui},model:{value:(_vm.suppliers_to_add),callback:function ($$v) {_vm.suppliers_to_add=$$v},expression:"suppliers_to_add"}}),_c('div',{attrs:{"id":"suppliersToAddTablePaging"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }